import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from '../util';
const Tiny = ({ color = 'var(--ambient-basePlus25)', className, height = 18, }) => (_jsx("svg", Object.assign({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", height: `${height}px`, viewBox: `0 -3 18 ${height}`, className: className }, { children: _jsx("path", { d: "M17.81 9.47h-1.59v-1h1.59zm-3.59 0h-2v-1h2zm-4 0h-2v-1h2zm-4 0h-2v-1h2zm-4 0h-2v-1h2z", fill: color }, void 0) }), void 0));
export const variants = {
    tiny: _jsx(Tiny, {}, void 0),
    default: _jsx(Tiny, {}, void 0),
};
export default withVariants(variants);
